<template>
  <!-- Overlay (karartma) -->
  <div
    v-if="stateStoreInstance.open"
    class="mahai-sidebar-overlay"
    @click="stateStoreInstance.onChange"
  ></div>

  <div
    :class="[
      'mahai-sidebar',
      { active: stateStoreInstance.open },
    ]"
    id="SidebarTheme"
  >
    <div class="mahai-sidebar-brand">
      <RouterLink to="/" class="mahai-sidebar-brand-link">
        <img :src="require('@/assets/images/ymlogo.png')" alt="Mahai" class="mahai-sidebar-logo-img" />
      </RouterLink>
    </div>

    <!-- Burger menü -->
    <div
      :class="['mahai-sidebar-toggle', { active: stateStoreInstance.open }]"
      @click="stateStoreInstance.onChange"
    >
      <span class="top-bar"></span>
      <span class="middle-bar"></span>
      <span class="bottom-bar"></span>
    </div>

    <!-- TEK SCROLL: Menü + History aynı scroll içinde -->
    <div
      class="mahai-sidebar-body"
      ref="sidebarScroll"
      @scroll.passive="handleSidebarScroll"
    >
      <!-- MENÜ -->
      <div class="mahai-sidebar-nav">
        <nav class="mahai-nav">
          <div class="mahai-nav-menu">
            <AccordionSlot>
              <template v-if="isAdmin">
                <span class="mahai-nav-label">ADMIN</span>

                <RouterLink to="/admin/users" class="mahai-nav-link" @click="closeSidebar">
                  <span class="material-symbols-outlined">people</span>
                  <span class="mahai-nav-text">Kullanıcılar</span>
                </RouterLink>

                <RouterLink to="/admin/stats" class="mahai-nav-link" @click="closeSidebar">
                  <span class="material-symbols-outlined">bar_chart</span>
                  <span class="mahai-nav-text">İstatistikler</span>
                </RouterLink>

                <RouterLink to="/admin/comparison-report" class="mahai-nav-link" @click="closeSidebar">
                  <span class="material-symbols-outlined">compare_arrows</span>
                  <span class="mahai-nav-text">Sistem Karşılaştırma</span>
                </RouterLink>

                <RouterLink to="/admin/parser" class="mahai-nav-link" @click="closeSidebar">
                  <span class="material-symbols-outlined">database</span>
                  <span class="mahai-nav-text">Parser Yönetimi</span>
                </RouterLink>
              </template>

              <span class="mahai-nav-label">MAHAI</span>
              <button
                type="button"
                class="mahai-nav-link mahai-nav-btn"
                :class="{ 'is-active': isNewChatActive }"
                @click="startNewChat"
              >
                <span class="material-symbols-outlined">chat</span>
                <span class="mahai-nav-text">Yeni Sohbet</span>
              </button>
              <button
                type="button"
                class="mahai-nav-link mahai-nav-btn"
                :class="{ 'is-active': isPrecedentSearchActive }"
                @click="openPrecedentSearch"
              >
                <span class="material-symbols-outlined">search</span>
                <span class="mahai-nav-text">Emsal Ara</span>
              </button>
              <RouterLink to="/apps/ai-principles" class="mahai-nav-link" @click="closeSidebar">
                <span class="material-symbols-outlined">gavel</span>
                <span class="mahai-nav-text">YZ Kullanım İlkeleri</span>
              </RouterLink>
              <!-- Karar Analizi: route canlı ama şimdilik kullanıma açılmadı (bilinçli gizli) -->
              <!--
              <RouterLink to="/apps/decision-analysis" class="mahai-nav-link" @click="closeSidebar">
                <span class="material-symbols-outlined">analytics</span>
                <span class="mahai-nav-text">Karar Analizi</span>
              </RouterLink>
              -->
              <RouterLink to="/authentication/logout" class="mahai-nav-link" @click="closeSidebar">
                <span class="material-symbols-outlined">logout</span>
                <span class="mahai-nav-text">Çıkış</span>
              </RouterLink>
            </AccordionSlot>
          </div>
        </nav>
      </div>

      <!-- HISTORY -->
      <div class="mahai-sidebar-history">
        <div class="mahai-history">
          <div class="mahai-history-header">
            <span class="mahai-history-title">Önceki Sohbetleriniz</span>
          </div>
          <div class="mahai-history-search">
            <i class="material-symbols-outlined mahai-search-icon">search</i>
            <input
              v-model="historySearch"
              @input="onHistorySearch"
              type="text"
              class="mahai-search-input"
              placeholder="Sohbet ara..."
            />
          </div>

          <div class="mahai-history-list" ref="historyList">
            <div
              v-if="conversationHistory.length === 0 && !historyLoading"
              class="mahai-history-empty"
            >
              Henüz sohbet yok
            </div>

            <div
              v-if="historyLoading && conversationHistory.length === 0"
              class="mahai-history-empty"
            >
              Yükleniyor...
            </div>

            <div
              v-for="conv in conversationHistory"
              :key="conv.id"
              class="mahai-history-item"
              :class="{
                'menu-open': openMenuId === conv.id,
                'is-active': activeConversationId === conv.id
              }"
              role="button"
              tabindex="0"
              @click="selectConversation(conv)"
              @keyup.enter="selectConversation(conv)"
            >
              <div class="mahai-history-row">
                <div class="mahai-history-text">
                  <input
                    v-if="editingId === conv.id"
                    v-model="editingValue"
                    class="mahai-history-input"
                    type="text"
                    @click.stop
                    @keyup.enter.stop="saveRename(conv)"
                    @keyup.esc.stop="cancelRename"
                  />
                  <span v-else class="mahai-history-question">
                    {{ conv.title || conv.preview || 'Sohbet' }}
                  </span>
                </div>

                <span
                  v-if="conv.is_pinned"
                  class="material-symbols-outlined mahai-history-pin"
                  title="Sabitlendi"
                  aria-label="Sabitlendi"
                >
                  push_pin
                </span>

                <button
                  class="mahai-history-menu-btn"
                  type="button"
                  title="Seçenekler"
                  @click.stop="toggleMenu(conv.id)"
                >
                  <i class="material-symbols-outlined">more_vert</i>
                </button>

                <div
                  v-if="openMenuId === conv.id"
                  class="mahai-history-menu"
                  @click.stop
                >
                  <button
                    class="mahai-history-menu-item"
                    type="button"
                    @click="startRename(conv)"
                  >
                    <i class="material-symbols-outlined mahai-menu-icon">edit</i>
                    Yeniden Adlandır
                  </button>

                  <button
                    class="mahai-history-menu-item"
                    type="button"
                    @click="pinConversation(conv)"
                  >
                    <span class="material-symbols-outlined mahai-menu-icon"
                          :class="{ 'pin-active': conv.is_pinned }">
                      push_pin
                    </span>
                    {{ conv.is_pinned ? 'Sabitlemeyi Kaldır' : 'Sohbeti Sabitle' }}
                  </button>

                  <button
                    class="mahai-history-menu-item"
                    type="button"
                    @click="archiveConversation(conv)"
                  >
                    <i class="material-symbols-outlined mahai-menu-icon">archive</i>
                    Arşivle
                  </button>

                  <button
                    class="mahai-history-menu-item danger"
                    type="button"
                    @click="deleteConversationAsk(conv)"
                  >
                    <i class="material-symbols-outlined mahai-menu-icon">delete</i>
                    Sil
                  </button>
                </div>
              </div>

              <span class="mahai-history-date">
                {{ formatConversationDate(conv.last_message_at) }}
              </span>
            </div>

            <div
              v-if="historyLoading && conversationHistory.length > 0"
              class="mahai-history-empty"
              style="padding: 10px 12px;"
            >
              Yükleniyor…
            </div>

            <div
              v-else-if="!historyHasMore && conversationHistory.length > 0"
              class="mahai-history-empty"
              style="padding: 10px 12px;"
            >
              Tüm sohbetler yüklendi.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DELETE MODAL -->
    <div v-if="pendingDeleteItem" class="mahai-modal-backdrop">
      <div class="mahai-modal">
        <div class="mahai-modal-title">Sohbeti sil</div>
        <div class="mahai-modal-text">
          Bu sohbeti silmek istediğinizden emin misiniz?
        </div>
        <div class="mahai-modal-actions">
          <button class="mahai-modal-btn ghost" type="button" @click="cancelDelete">
            Vazgeç
          </button>
          <button class="mahai-modal-btn danger" type="button" @click="confirmDelete">
            Sil
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted, onUnmounted, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";
import stateStore from "@/utils/store";
import AccordionSlot from "./AccordionSlot.vue";

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

export default defineComponent({
  name: "LeftSidebar",
  components: { AccordionSlot },
  setup() {
    const stateStoreInstance = stateStore;
    const route = useRoute();
    const router = useRouter();
    const perPage = 20;

    const user = ref(null);

    const activeConversationId = ref(null);
    const conversationHistory = ref([]);
    const historyList = ref(null);

    const sidebarScroll = ref(null);

    const historyPage = ref(1);
    const historyLoading = ref(false);
    const historyHasMore = ref(true);

    const openMenuId = ref(null);
    const editingId = ref(null);
    const editingValue = ref("");

    const pendingDeleteItem = ref(null);
    const isPrecedentSearchActive = ref(false);

    const historySearch = ref("");
    let historySearchTimer = null;

    // Yeni Sohbet aktif mi: LawAssistant sayfasındayken, sohbet seçili değilse ve emsal arama açık değilse
    const isNewChatActive = computed(() => {
      const isLawAssistantPage = route.name === "LawAssistantPage" || route.path === "/apps/decisions-ai";
      return isLawAssistantPage && !activeConversationId.value && !isPrecedentSearchActive.value;
    });

    const isAdmin = computed(() => {
      if (!user.value) return false;
      if (user.value.is_admin) return true;
      if (Array.isArray(user.value.roles)) {
        return user.value.roles.some((r) => r.name === "admin");
      }
      return false;
    });

    const authHeader = () => {
      const token = localStorage.getItem("auth_token");
      return token ? { Authorization: `Bearer ${token}` } : null;
    };

    const fetchCurrentUser = async () => {
      try {
        const headers = authHeader();
        if (!headers) return;

        const res = await axios.get(`${API_BASE_URL}/user`, {
          headers: { ...headers, "Content-Type": "application/json" },
        });

        user.value = res.data;
      } catch (e) {
        console.error("Kullanıcı bilgisi alınırken hata:", e);
      }
    };

    const fetchConversations = async ({ reset = false } = {}) => {
      const headers = authHeader();
      if (!headers) {
        conversationHistory.value = [];
        historyPage.value = 1;
        historyHasMore.value = false;
        return;
      }

      if (historyLoading.value) return;
      if (!historyHasMore.value && !reset) return;

      historyLoading.value = true;
      if (reset) {
        historyPage.value = 1;
        historyHasMore.value = true;
      }

      try {
        const params = { page: historyPage.value, per_page: perPage };
        if (historySearch.value.trim()) {
          params.q = historySearch.value.trim();
        }

        const res = await axios.get(`${API_BASE_URL}/conversations`, {
          headers,
          params,
        });

        const data = res.data || {};
        const items = data.conversations || data.items || data.data || [];

        const hasMore =
          typeof data.has_more === "boolean"
            ? data.has_more
            : data.meta
              ? (data.meta.current_page < data.meta.last_page)
              : (items.length === perPage);

        if (reset) {
          conversationHistory.value = items;
        } else {
          conversationHistory.value = conversationHistory.value.concat(items);
        }

        historyHasMore.value = !!hasMore;
        if (historyHasMore.value) historyPage.value += 1;
      } catch (e) {
        console.error("Sohbetler yüklenemedi:", e);
      } finally {
        historyLoading.value = false;
      }
    };

    const formatConversationDate = (dateStr) => {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      const now = new Date();
      const diff = now - d;

      if (diff < 86400000 && d.getDate() === now.getDate()) {
        return "Bugün " + d.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
      }

      const yesterday = new Date(now);
      yesterday.setDate(yesterday.getDate() - 1);
      if (d.getDate() === yesterday.getDate() && d.getMonth() === yesterday.getMonth()) {
        return "Dün";
      }

      return d.toLocaleDateString("tr-TR", { day: "numeric", month: "short" });
    };

    const closeSidebar = () => {
      if (stateStoreInstance.open) {
        stateStoreInstance.onChange();
      }
    };

    const selectConversation = async (conv) => {
      if (!conv?.id) return;

      activeConversationId.value = conv.id;
      isPrecedentSearchActive.value = false;
      await router.push({ name: "LawAssistantPage" });
      window.dispatchEvent(
        new CustomEvent("decisions-ai-conversation-select", { detail: conv })
      );
      openMenuId.value = null;
      closeSidebar();
    };

    const toggleMenu = (id) => {
      openMenuId.value = openMenuId.value === id ? null : id;
    };

    const startRename = (conv) => {
      editingId.value = conv.id;
      editingValue.value = (conv.title || conv.preview || "").trim();
      openMenuId.value = null;
    };

    const cancelRename = () => {
      editingId.value = null;
      editingValue.value = "";
    };

    const saveRename = async (conv) => {
      const nextValue = editingValue.value.trim();
      if (!nextValue) {
        cancelRename();
        return;
      }

      const headers = authHeader();
      if (!headers) return;

      try {
        const res = await axios.patch(
          `${API_BASE_URL}/conversations/${conv.id}`,
          { title: nextValue },
          { headers }
        );

        const updated = res.data?.conversation || res.data?.item || res.data || null;

        if (updated) {
          conversationHistory.value = conversationHistory.value.map((c) =>
            c.id === conv.id ? { ...c, ...updated } : c
          );
        } else {
          conversationHistory.value = conversationHistory.value.map((c) =>
            c.id === conv.id ? { ...c, title: nextValue } : c
          );
        }
      } catch (e) {
        console.error("Sohbet yeniden adlandırılamadı:", e);
      } finally {
        cancelRename();
      }
    };

    const deleteConversationAsk = (conv) => {
      openMenuId.value = null;
      pendingDeleteItem.value = conv;
    };

    const cancelDelete = () => {
      pendingDeleteItem.value = null;
    };

    const confirmDelete = async () => {
      if (!pendingDeleteItem.value) return;
      const conv = pendingDeleteItem.value;

      if (activeConversationId.value === conv.id) {
        activeConversationId.value = null;
      }

      const headers = authHeader();
      if (!headers) return;

      try {
        const res = await axios.delete(`${API_BASE_URL}/conversations/${conv.id}`, { headers });

        if (res.data?.ok !== false) {
          conversationHistory.value = conversationHistory.value.filter((c) => c.id !== conv.id);

          window.dispatchEvent(
            new CustomEvent("decisions-ai-conversation-deleted", { detail: conv.id })
          );
        }
      } catch (e) {
        console.error("Sohbet silinemedi:", e);
      } finally {
        pendingDeleteItem.value = null;
      }
    };

    const handleDocumentClick = () => {
      openMenuId.value = null;
    };

    const startNewChat = async () => {
      activeConversationId.value = null;
      isPrecedentSearchActive.value = false;
      await router.push({ name: "LawAssistantPage" });
      window.dispatchEvent(new Event("decisions-ai-new-chat"));
      await fetchConversations({ reset: true });

      nextTick(() => {
        if (sidebarScroll.value) sidebarScroll.value.scrollTop = 0;
      });

      closeSidebar();
    };

    const openPrecedentSearch = async () => {
      isPrecedentSearchActive.value = true;
      activeConversationId.value = null;
      await router.push({ name: "LawAssistantPage" });
      window.dispatchEvent(
        new CustomEvent("decisions-ai-precedent-search", { detail: {} })
      );
      closeSidebar();
    };


    // Emsal arama modalı kapandığında
    const handlePrecedentSearchClosed = () => {
      isPrecedentSearchActive.value = false;
    };

    const handleSidebarScroll = (e) => {
      const el = e?.target || sidebarScroll.value;
      if (!el || historyLoading.value || !historyHasMore.value) return;

      const threshold = 160;
      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;
      if (nearBottom) fetchConversations();
    };

    const handleHistoryRefresh = () => {
      fetchConversations({ reset: true });
    };

    const onAuthChanged = async () => {
      historyPage.value = 1;
      historyHasMore.value = true;
      conversationHistory.value = [];

      await fetchConversations({ reset: true });
      nextTick(() => {
        if (sidebarScroll.value) sidebarScroll.value.scrollTop = 0;
      });

      fetchCurrentUser();
    };

    const pinConversation = async (conv) => {
      const headers = authHeader();
      if (!headers || !conv?.id) return;

      try {
        await axios.post(
          `${API_BASE_URL}/conversations/${conv.id}/pin`,
          null,
          { headers }
        );

        await fetchConversations({ reset: true });
      } catch (e) {
        console.error("Sohbet sabitlenemedi:", e);
      } finally {
        openMenuId.value = null;
      }
    };

    const archiveConversation = async (conv) => {
      const headers = authHeader();
      if (!headers || !conv?.id) return;

      try {
        await axios.patch(
          `${API_BASE_URL}/conversations/${conv.id}`,
          { archived: true },
          { headers }
        );

        await fetchConversations({ reset: true });
      } catch (e) {
        console.error("Sohbet arşivlenemedi:", e);
      } finally {
        openMenuId.value = null;
      }
    };


    onMounted(() => {
      fetchCurrentUser();
      fetchConversations({ reset: true });

      window.addEventListener("decisions-ai-history-refresh", handleHistoryRefresh);
      document.addEventListener("click", handleDocumentClick);
      window.addEventListener("auth-changed", onAuthChanged);
      window.addEventListener("decisions-ai-precedent-search-closed", handlePrecedentSearchClosed);
    });

    onUnmounted(() => {
      window.removeEventListener("decisions-ai-history-refresh", handleHistoryRefresh);
      document.removeEventListener("click", handleDocumentClick);
      window.removeEventListener("auth-changed", onAuthChanged);
      window.removeEventListener("decisions-ai-precedent-search-closed", handlePrecedentSearchClosed);
    });

    watch(
      () => route.path,
      async () => {
        await nextTick();
        await fetchConversations({ reset: true });
        nextTick(() => {
          if (sidebarScroll.value) sidebarScroll.value.scrollTop = 0;
        });
      }
    );

    return {
      stateStoreInstance,
      isAdmin,
      isNewChatActive,
      isPrecedentSearchActive,

      conversationHistory,
      historyList,
      historyLoading,
      historyHasMore,

      sidebarScroll,
      handleSidebarScroll,

      openMenuId,
      editingId,
      editingValue,
      pendingDeleteItem,

      selectConversation,
      toggleMenu,
      startRename,
      saveRename,
      cancelRename,

      deleteConversationAsk,
      cancelDelete,
      confirmDelete,

      startNewChat,
      openPrecedentSearch,
      formatConversationDate,

      activeConversationId,
      fetchConversations,
      pinConversation,
      archiveConversation,
      closeSidebar,
      historySearch,
      onHistorySearch: () => {
        if (historySearchTimer) clearTimeout(historySearchTimer);
        historySearchTimer = setTimeout(() => {
          fetchConversations({ reset: true });
        }, 400);
      },
    };
  },
});
</script>

<style lang="scss" src="@/assets/scss/mahai-sidebar.scss"></style>
